import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '../../../shared/Typography/PageTitle';
import { GeneralTable } from '../../../shared/Table/GeneralTable';
import useLiveOrders from '../../../../hooks/liveOrders/useLiveOrders';
import { LIVE_ORDERS_HEAD_CELLS } from '../../../../utils/constans/tableHeads/liveOrdersTableHead';
import { LiveOrdersData } from '../../../../models/LiveOrders';
import { LiveOrdersTableRow } from '../../../liveOrders/LiveOrdersTableRow';

export const LiveOrders = () => {
    const { t } = useTranslation('liveOrders');
    const liveOrders = useLiveOrders();
    const fullList = liveOrders.getLiveOrders();
    const isLoading = false;
    const tableHeadSettings = {
        translateNs: 'liveOrders',
        translatePrefix: 'LIVE_ORDERS.TABLE_HEAD',
        selectable: false,
        headContent: LIVE_ORDERS_HEAD_CELLS,
    };

    const tableToolbarSettings = {
        translateNs: 'liveOrders',
        translatePrefix: 'LIVE_ORDERS.TABLE_TOOLBAR',
    };

    const filterTerm = (search) => {
        return fullList.filter((elem) => {
            return (
                elem.orderNumber.includes(search) ||
                elem.status.toLowerCase().includes(search.toLowerCase()) ||
                elem.price_net.includes(search)
            );
        });
    };

    const forceRefresh = () => {};

    return (
        <>
            <>
                <PageTitle>{t('LIVE_ORDERS.PAGE_TITLE')}</PageTitle>
                <GeneralTable<LiveOrdersData, LiveOrdersData>
                    fullList={fullList}
                    rowComponent={LiveOrdersTableRow}
                    filterTerm={filterTerm}
                    defaultOrderBy={'date'}
                    selectHandleId={'orderNumber'}
                    tableHeadSettings={tableHeadSettings}
                    tableToolbarSettings={tableToolbarSettings}
                    forceRefresh={forceRefresh}
                    isLoading={isLoading}
                />
            </>
        </>
    );
};
